import { LocationUtilities, SiteUtilities } from '../utils';
import Cookie from 'js-cookie';
import GA4Utilities from '../utils/ga4-utilities';

const freddySignupForm = (classname, form) => {
  const $form = $(form);
  const $errorWrapper = $form.find('.error-wrapper');
  const signUpApiUrl = $form.data('signup-url') || 'https://www.freshbots.ai/rest/client/v2/';
  const redirect = $form.attr('data-redirect');
  const email = $form.find('input[name^="email"]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const firstName = $form.find('.first-name-form').val() || '';
  const lastName = $form.find('.last-name-form').val() || '';
  const phoneNumber = $form.find('.phone-form').val() || '';
  const companyName = $form.find('.company-form').val() || '';
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();
  const currentLoc = SiteUtilities.getCurrentLocation();

  // start button loading animation and disable button
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  const data = {
    usrNm: `${firstName} ${lastName}`,
    eml: email,
    dmn: companyName.replace(/\s+/gi, ''),
    phn: phoneNumber,
    frst_rfr: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || currentLoc)
  };

  if (!SiteUtilities.GDPRFunctionalCookieDisabled()) {
    data['cty'] = geoLocation ? geoLocation.cityName : '';
    data['st'] = geoLocation ? geoLocation.regionName : '';
    data['cntry'] = geoLocation ? geoLocation.countryName : '';
  } else {
    data['cntry'] = geoLocation ? geoLocation.countryName : '';
  }

  const freddySignupSuccessHandler = (clnt) => {
    const { clntHsh, dmn, prdctHsh } = clnt;

    $errorWrapper.removeClass('error');
    const freshmarketerData = {
      freshmarketerObject: {
        email: email,
        phone: phoneNumber,
        country: geoLocation ? geoLocation.countryName : '',
        contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
        custom_field: {
          cf_fmarketersignupreferrer: window.location.href || '',
          cf_freshmarketer_list: $form.find('.fm-list-id').val()
        }
      }
    };

    // Redirect to thank-you page once Freshmarketer Post is complete.
    SiteUtilities.freshmarketerPost(freshmarketerData, false, form).then(() => {
      jQuery('body').trigger('trackingCompleted');
    });
    jQuery('body').on('trackingCompleted', () => {
      setTimeout(() => {
        let thankYouRedirect = `${redirect}/?url=${encodeURIComponent(dmn)}&product_hash=${prdctHsh}&client_hash=${clntHsh}&ehash=${emailHash}`;
        if (isExternalIframeSignup) {
          thankYouRedirect += '&post_to_partner=true';
          if (currentReferrer) {
            thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
          }
        }
        window.location.href = thankYouRedirect;
      }, 1500);
    });
  };

  const freddySignupErrorHandler = (error) => {
    $form.addClass('error');
    $errorWrapper.empty();
    if (error.cd === 1001 || error.cd === 500) {
      // If given domain/company name already exists and if domain is not valid
      $('.company-form').closest('.form-field').find('.error-wrapper').append('<em class="error">' + error.msg + '</em>');
    }
  };

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: JSON.stringify(data),
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    success: ({ data }) => {
      const { error, clnt } = data;
      if (error) {
        freddySignupErrorHandler(error);
        GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
      } else {
        GA4Utilities.fwFormSubmit(classname, { company: companyName, email, firstName, lastName, phone: phoneNumber });
        freddySignupSuccessHandler(clnt);
      }
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.addClass('error');
      $errorWrapper.empty().append('<em class="error">Backend error</em>');
      GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

export default { freddySignupForm };
